import { FunctionComponent, h } from 'preact'
import cls from 'classnames'
import { Field, FieldEntry, RadioSelectField } from 'scripts/type'

import classes from './radio.module.scss'
import { useState } from 'preact/hooks'

type Props = {
  field: Field
  onRadioValueChange?: (fieldEntry: FieldEntry) => void
}

const RadioButtonField: FunctionComponent<Props> = ({ field, onRadioValueChange }) => {
  const { choices } = field as RadioSelectField
  const [value, setValue] = useState<string>()

  const handleClick = (value: string) => {
    setValue(value)
    onRadioValueChange?.({
      code: field.code,
      value: {
        value: [value],
      },
    })
  }

  return (
    <div className={classes.radioField}>
      {choices.map((choice) => (
        <div
          className={cls(classes.choice, value === choice.value && classes.selected)}
          key={choice.value}
          onClick={() => handleClick(choice.value)}
        >
          {choice.label}
        </div>
      ))}
    </div>
  )
}

export default RadioButtonField
